module.exports = __webpack_public_path__ + "img/guide1-6.3460e482.png";